
<script>
  import {staffMember, roomRequest} from '../stores';
  import { createEventDispatcher } from 'svelte';
  import {setSrc} from '../utils';
  export let item = {};
  let src = "/icons/room.svg";
  const dispatch = createEventDispatcher();

  function roomClick() {
    roomRequest.set(item);
   dispatch('roomevent', {
     item: item
   });
  }

  $: active = $roomRequest.guid == item.guid ? 1 : 0;


</script>

  <button type="button" on:click="{roomClick}" class="button room-number" class:active={active} disabled={$staffMember == 0 ?  true: false} data-id="{item.guid}">
    <span class='icon'><span class="fa-solid fa-door-open"></span><!--<img src={setSrc(src, item.image)} alt={item.name} />--></span>
    <span class="text">{item.name}</span>
  </button>
